/**
 * Utilidades para entrega y estado
 */

import { getStatusStoneDelivery } from "../ConnectDataBase";

/**
 * Obtiene el estado de entrega
 * @param {string} codeScan - Código de escaneo
 * @param {string} codePage - Código de página
 * @param {string} status - Estado
 * @param {string} PO - Purchase Order
 * @returns {Promise<Array>} Estado de entrega [piedras, taller]
 */
export async function getStatusDelivery(codeScan, codePage, status, PO) {
  let estado = [false, false];
  try {
    const statusDelivery = await getStatusStoneDelivery(
      codeScan,
      codePage,
      status,
      PO
    );

    if (
      statusDelivery[0]?.fecha_ok_piedras &&
      statusDelivery[0]?.fecha_ok_piedras !== "0000-00-00 00:00:00" &&
      statusDelivery[0]?.usuario_ok_piedras
    ) {
      estado = [true, false];
    }
    if (
      statusDelivery[0]?.fecha_ok_taller &&
      statusDelivery[0]?.fecha_ok_taller !== "0000-00-00 00:00:00" &&
      statusDelivery[0]?.usuario_ok_taller
    ) {
      estado = [true, true];
    }
  } catch (error) {
    // Manejo de errores
    console.error(error);
  }
  return estado;
}
